import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link, useLocation } from "react-router-dom";
import importantLogo from "../../assets/images/star.png";
import "./style/notification.css";
import { convertFirstLetterOfFullNameToCapital } from "../../helpers/commonHelpers";
import NotificationDropdown from "./NotificationDropDown";
import NotificationDropdownAll from "./NotificationDropDownAll";
import NotificationFilterDropDown from "./NotificationFilterDropDown";
import Alert from "../Common/Alert";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import { logOut } from "../../redux/actions/authActions/authAction";
import BackButton from "../Common/Backbutton";
const ViewNotification = () => {
  useEffect(() => {
    document.title = "Notification: MinutesVault";
  });
  const [notification, setNotification] = useState([]);
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [isChecked, setIsChecked] = useState(false); // controls the checkbox
  const location = useLocation();
  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const notificationData = useSelector((state) => state.notification);

  const handleToggleSelectAll = () => {
    if (
      selectedNotifications.length === notificationData.notificationList.length
    ) {
      setSelectedNotifications([]);
    } else {
      const allIds = notificationData.notificationList.map((n) => n._id);
      setSelectedNotifications(allIds);
    }
  };
  const handleToggleNotification = (id) => {
    setSelectedNotifications((prev) =>
      prev.includes(id) ? prev.filter((nid) => nid !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    const allIds = notificationData?.notificationList?.map((n) => n._id) || [];
    setSelectedNotifications(allIds);
  };

  const handleDeselectAll = () => {
    setSelectedNotifications([]);
  };

  // This function is called when operation is complete
  const handleOperationComplete = () => {
    setIsChecked(false); // uncheck the box
  };

  const clearSelectedNotifications = () => {
    setSelectedNotifications([]); // or whatever your state updater is
  };

  return (
    <>
      <div className="main-content">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
            <section className="notification-page">
              <div className="meeting-header-text  line-height-h4 justify-content-between">
                <div>
                  <h4>
                    Notifications: {notificationData?.notificationList?.length}
                  </h4>
                </div>
                <div className="d-flex gap-2">
                  {notificationData?.notificationList?.length > 0 && (
                    <NotificationFilterDropDown />
                  )}

                  <BackButton show={camefromPreviousPage} />
                </div>
              </div>

             

              <div className="table-box mt-2 p-0">
                <div
                  className={
                    notificationData?.notificationList?.length > 0
                      ? "mt-3 d-flex justify-content-between notification unseen"
                      : ""
                  }
                >
                  {notificationData?.notificationList?.length > 0 && (
                    <div className="checkbox-with-delete d-flex gap-2 align-items-center notification-min-height">
                      <input
                        type="checkbox"
                        checked={
                          notificationData?.notificationList?.length > 0 &&
                          selectedNotifications.length ===
                            notificationData?.notificationList.length
                        }
                        onChange={() => {
                          if (
                            selectedNotifications.length ===
                            notificationData?.notificationList?.length
                          ) {
                            handleDeselectAll();
                          } else {
                            handleSelectAll();
                          }
                        }}
                        className="mark-all-checkbox notification-checkbox1"
                      />
                      <label>Select All</label>
                    </div>
                  )}

                  <div className="select-notification-right">
                    {selectedNotifications.length > 0 ? (
                      <NotificationDropdownAll
                        notificationId={selectedNotifications}
                        notification={notificationData.notificationList}
                        onOperationComplete={handleOperationComplete}
                        clearSelectedNotifications={clearSelectedNotifications}
                      />
                    ) : null}
                  </div>
                </div>
                {notificationData?.notificationList?.length !== 0 ? (
                  <>
                    {notificationData?.notificationList?.map((notification) => {
                      const isSelected = selectedNotifications.includes(
                        notification._id
                      );

                      return (
                        <div
                          key={notification._id}
                          className={`notification-row ${
                            isSelected ? "selected" : ""
                          }`}
                        >
                          {/* Checkbox like Gmail */}

                          <div className="notification-content">
                            <div
                              className={
                                notification.isRead
                                  ? "notification"
                                  : "notification unseen"
                              }
                            >
                              <div className="inner-notification">
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={() =>
                                    handleToggleNotification(notification._id)
                                  }
                                  className="notification-checkbox notification-checkbox1"
                                />
                                <div className="text">
                                  <div className="heading">
                                    {notification?.isImportant && (
                                      <img src={importantLogo} />
                                    )}
                                    <Link
                                      style={{
                                        textDecoration:
                                          notification?.type === "MEETING" ||
                                          notification?.type === "ACTION" ||
                                          notification?.type === "MINUTE" ||
                                          notification?.type === "COMMENT"
                                            ? ""
                                            : "none",
                                        cursor:
                                          notification?.type === "MEETING" ||
                                          notification?.type === "ACTION" ||
                                          notification?.type === "MINUTE" ||
                                          notification?.type === "COMMENT"
                                            ? ""
                                            : "auto",
                                      }}
                                      to={
                                        notification?.type === "MEETING"
                                          ? `/view-meeting-details/${notification?.typeId?.toString()}`
                                          : notification?.type === "ACTION"
                                            ? `/view-action-details/${notification?.typeId?.toString()}`
                                            : notification?.type === "MINUTE"
                                              ? `/view-minute-details/${notification?.typeId?.toString()}`
                                              : notification?.type === "COMMENT"
                                                ? `/view-action-detail/${notification?.typeId?.toString()}`
                                                : undefined
                                      }
                                      state={{
                                        camefromPreviousPage: true,
                                        scrollToId: `${notification.commentId}`,
                                      }}
                                    >
                                      {convertFirstLetterOfFullNameToCapital(
                                        notification.title
                                      )}
                                    </Link>
                                  </div>

                                  <div className="text-editor">
                                    {notification?.details &&
                                      convertFirstLetterOfFullNameToCapital(
                                        notification.details
                                      )}
                                  </div>

                                  <div className="text-editor">
                                    Meeting Title:{" "}
                                    {notification?.meetingTitle &&
                                      convertFirstLetterOfFullNameToCapital(
                                        notification.meetingTitle
                                      )}
                                  </div>

                                  <div className="date">
                                    {notification.date} , {notification.time}
                                  </div>
                                </div>
                              </div>

                              {selectedNotifications.length === 0 && (
                                <div className="d-inline-block menu-dropdown custom-dropdown notification-dropdown">
                                  <NotificationDropdown
                                    notificationId={notification._id}
                                    notification={notification}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) : !notificationData?.loading &&
                  notificationData?.notificationList?.length === 0 ? (
                  <div className="no-data-img mt-3 notify-padding">
                    <Alert
                      status={"info"}
                      message={"No data available."}
                      timeoutSeconds={0}
                    />

                    <NoDataFound dataType={"meeting"} />
                  </div>
                ) : (
                  <div
                    className="meeting-page"
                    style={{ textAlign: "center", paddingTop: 20 }}
                  >
                    <Loader />
                  </div>
                )}
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewNotification;
